import { useRef } from "react";
import { Lista } from "./styled";

/**
 * Abas acessíveis (padrão WAI-ARIA "tabs"): setas esquerda/direita, Home e End
 * movem entre abas; só a aba ativa entra na ordem do Tab. O CONTEÚDO fica por
 * conta de quem usa (um painel com role="tabpanel"), para montar só o da aba
 * ativa e não buscar dados de abas que ninguém abriu.
 *
 * `abas`: [{ id, rotulo, selo? }]  (`selo`: número de pendentes mostrado ao lado do rótulo)   `ativa`: id   `onChange(id)`   `idBase`: prefixo dos ids
 */
export default function Abas({ abas, ativa, onChange, idBase = "aba", rotulo = "Seções" }) {
  const refs = useRef({});

  function aoTeclar(e, indice) {
    const ultimo = abas.length - 1;
    let destino = null;
    if (e.key === "ArrowRight") destino = indice === ultimo ? 0 : indice + 1;
    else if (e.key === "ArrowLeft") destino = indice === 0 ? ultimo : indice - 1;
    else if (e.key === "Home") destino = 0;
    else if (e.key === "End") destino = ultimo;
    if (destino === null) return;
    e.preventDefault();
    onChange(abas[destino].id);
    refs.current[abas[destino].id]?.focus();
  }

  return (
    <Lista role="tablist" aria-label={rotulo}>
      {abas.map((aba, i) => {
        const selecionada = aba.id === ativa;
        return (
          <button
            key={aba.id}
            ref={(el) => { refs.current[aba.id] = el; }}
            type="button"
            role="tab"
            id={`${idBase}-${aba.id}`}
            aria-selected={selecionada}
            aria-controls={`${idBase}-painel-${aba.id}`}
            tabIndex={selecionada ? 0 : -1}
            className={selecionada ? "ativa" : undefined}
            onClick={() => onChange(aba.id)}
            onKeyDown={(e) => aoTeclar(e, i)}
          >
            {aba.rotulo}
            {aba.selo > 0 &&
              <b className="selo-aba" aria-label={`${aba.selo} pendente${aba.selo === 1 ? "" : "s"}`}>{aba.selo}</b>
            }
          </button>
        );
      })}
    </Lista>
  );
}
